import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  & div > img {
    max-width: 580px;
  }

  & div > div > .description {
    & > [class^="heading-"] {
      & > div p {
        margin-bottom: calc(var(--space-unit) * 5);
        font-size: 20px;
      }
      & span {
        font-weight: bold;
        display: block;
      }
    }
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    & div > div > .description {
      & > [class^="heading-"] {
        & span {
          display: inline-block;
        }
      }
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
    & div > div > .description {
      & > [class^="heading-"] {
        & p {
          font-size: calc(var(--space-unit) * 3);
        }
      }
    }
  }
`;
